/**
 * Route for `google-ads-gclid-parallel-tracking-native-integrat`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { GoogleAdsGclidParallelTrackingNativeIntegratPage } from "../features/google-ads-gclid-parallel-tracking-native-integrat/GoogleAdsGclidParallelTrackingNativeIntegratPage";

export const googleAdsGclidParallelTrackingNativeIntegratRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/google-ads-gclid-parallel-tracking-native-integrat",
	component: GoogleAdsGclidParallelTrackingNativeIntegratPage,
});

export default googleAdsGclidParallelTrackingNativeIntegratRoute;
